import { render, staticRenderFns } from "./sap-export-button.vue?vue&type=template&id=b70803f4&scoped=true"
import script from "./sap-export-button.vue?vue&type=script&lang=js"
export * from "./sap-export-button.vue?vue&type=script&lang=js"
import style0 from "./sap-export-button.vue?vue&type=style&index=0&id=b70803f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70803f4",
  null
  
)

export default component.exports